<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>


  export default {
    name: 'App',
    data(){
        return{

        }
    },
    created(){
        var url = window.location.host;
        if(url=='insadm.ltylao.com'){
          document.title = '乐庭智慧机构养老综合管理系统';
        }else if(url=='xlyjgyl.ltylao.com'){
          document.title = '夕乐苑智慧机构养老综合管理系统';
        }else if(url=='ahygs-ins.ltylao.com'){
          document.title = '云硅山智慧机构养老综合管理系统';
        }else if(url=='yian.ltylao.com'){
          document.title = '来凤颐安智慧机构养老综合管理系统';
        }else{
          document.title = 'debug';
        }

    },
  }
</script>

<style>
  html,body{padding: 0px;margin: 0px;height: auto;}
  #app{height: 100%;}
</style>
